import { Cross } from '@react-vant/icons';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Image, ImagePreview, Toast } from 'react-vant';
import { apiGetH5Config, apiGetH5RefundCancel, apiGetH5RefundDetail } from '../api';
import { getSafeLandingLink } from '../utils/landingPage';
import AppBar from '../components/appBar';
import Page from '../components/page';
import main from '../main';
import { ApplyRefund, Order } from '../types';
import { cancelReasonData, cardOrderStatusData, operatorsTypeData } from '../utils/source';
import { dictLabel, parseLocationParams } from '../utils/utils';

export default function ApplySalesPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [id, setid] = useState<string>();
  const [applySalesData, setApplySalesData] = useState<{ [x: string]: Order | null | any }>();

  useEffect(() => {
    let _p = parseLocationParams(location.search) ?? {};
    if (_p.id) {
      setid(_p.id);
      getH5RefundDetail(_p.id);
      
      
    }
    if(!main.serviceLink){
      loadH5Config()
    }
  }, []); // eslint-disable-line
  async function loadH5Config() {
    try {
      let res = await apiGetH5Config(); 
      let data = res.data;
      if (data.code === 200) {
        let _data = data.data || {};
        main.serviceLink = _data.serviceLink;
        sessionStorage.setItem('serviceLink', _data.serviceLink ?? '');
      }
    } catch (e) { }
  }
  async function getH5RefundDetail(id: string) {
    try {
      let res = await apiGetH5RefundDetail({ id });
      let data = res.data;
      if (data.code === 200) {
        setApplySalesData(data.data);
      }
    } catch (error) {}
  }

  async function cancelRefund(id: string) {
    let res = await apiGetH5RefundCancel({ id });
    let data = res.data;
    if (data.code === 200) {
      Toast(data?.msg ?? '操作成功');
      getH5RefundDetail(id!);
    } else {
      Toast(data?.msg ?? '操作失败');
    }
  }
  async function handleCancel(item: ApplyRefund) {
    Dialog.confirm({
      title: '取消申请',
      message: '确定取消申请吗',
      confirmButtonColor: '#f86404',
    })
      .then(() => {
        cancelRefund(item.id!);
      })
      .catch(() => {});
  }

  let order: Order = applySalesData?.order;
  let refundList = applySalesData?.refundList;

  return (
    <Page
      className="applysales-page d-flex-c"
      contentClassName="flex-1 h-1 mb-10 overflow-y"
      appBar={<AppBar className="bg-transparent" title="选择售后类型" />}
    >
      <div className="bg-white border-bottom p-15">
        <div className="d-flex-r ai-center jc-between font-size-16 font-widget-500 pb-5">
          <div>{dictLabel(order?.operatorsType, operatorsTypeData)}通信专营授权店</div>
          <div className="text-color-p">
            {order?.orderPayStatus === 'wait'
              ? '待支付'
              : order?.orderPayStatus === 'z-close'
              ? '已关闭'
              : dictLabel(order?.orderStatus, cardOrderStatusData)}
          </div>
        </div>
        <div className="d-flex-r mt-10">
          <img className="w-80 h-80 border-radius-4" src={order?.goodsHeadImg} alt="" />
          <div className="flex-1 ml-15 d-flex-c">
            <div className="flex-1 omit-text-2">{order?.orderName}</div>
            <div className="d-flex-r ai-center jc-between">
              <div>
                <span className="text-color-3">实付金额：</span>
                {Number(order?.payAmount ?? 0).toFixed(2)}
              </div>
              <div className="text-color-6 d-flex-r ai-center">
                <Cross className="mr-3" />1
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-10">
        <div className="d-flex-r ai-center mb-10">
          <div className="w-5 h-20 bg-p border-radius-4 mr-5"></div>
          <span className="font-widget-500 font-size-16">联系客服</span>
        </div>
        <div
          className="bg-white border-radius-8 p-15 d-flex-r text-color-6 mb-20"
          onClick={() => {
            const serviceLink = getSafeLandingLink(main.serviceLink);
            if(serviceLink){
              window.location.href = serviceLink
            }else{
              Toast('暂无客服链接');
            }
          }}
        >
          <div>针对订单的各类问题，咨询客服，由客服协助您服务处理您的问题</div>
          <img className="w-15 h-15 mt-5 ml-10" src="/pic/icon_right_arrow.png" alt="" />
        </div>

        {(refundList ?? []).length === 0 && Number(order?.payAmount ?? 0) > 0 && (
          <>
            <div className="d-flex-r ai-center mb-10">
              <div className="w-5 h-20 bg-p border-radius-4 mr-5"></div>
              <span className="font-widget-500 font-size-16">申请退款</span>
            </div>
            <div
              className="bg-white border-radius-8 p-15 d-flex-r text-color-6 mb-20"
              onClick={() => navigate(`/applyRefund?id=${id}`)}
            >
              <div>未收到货/拒收，或与商家协商一致后，可发起退款申请</div>
              <img className="w-15 h-15 mt-5 ml-10" src="/pic/icon_right_arrow.png" alt="" />
            </div>
          </>
        )}
        {!!refundList?.length && (
          <div>
            <div className="d-flex-r ai-center mb-10">
              <div className="w-5 h-20 bg-p border-radius-4 mr-5"></div>
              <span className="font-widget-500 font-size-16">退款申请</span>
            </div>
            {refundList.map((item: ApplyRefund, idx: number) => (
              <div key={idx} className="mt-10 bg-white border-radius-8 p-20 d-flex-c">
                <div className="d-flex-r ai-center jc-between">
                  <span className="text-color-6">退款进度</span>
                  <div className="text-color-p">{item?.auditDesc}</div>
                </div>
                <div className="d-flex-r ai-center jc-between pt-15">
                  <span className="text-color-6">退款原因</span>
                  <div>{dictLabel(item?.refundReason, cancelReasonData)}</div>
                </div>
                <div className="d-flex-r ai-center jc-between pt-15">
                  <span className="text-color-6">申请退款金额</span>
                  <div>{item?.practicalAmount}</div>
                </div>
                <div className="d-flex-c pt-15">
                  <span className="text-color-6">补充描述</span>
                  <div className="mt-5 bg-gray p-10 pb-50 border border-radius-8">{item?.refundDesc}</div>
                </div>
                <div className="d-flex-r ai-center pt-15">
                  {!!item.refundImgPath &&
                    item.refundImgPath
                      .split(',')
                      .map((i) => (
                        <Image
                          key={i}
                          width="60"
                          height="60"
                          fit="cover"
                          className="mr-10"
                          src={i}
                          onClick={() => ImagePreview.open({ images: [i] })}
                        />
                      ))}
                </div>
                {item?.auditDesc === '审核中' && (
                  <div className="d-flex-r jc-end">
                    <div
                      className="cancel-btn mt-10 text-color-p border-radius-20 pl-10 pr-10 pt-5 pb-5"
                      onClick={() => handleCancel(item)}
                    >
                      取消申请
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Page>
  );
}
